import { render } from "./conversation-page.vue?vue&type=template&id=e161b52c"
import script from "./conversation-page.js?vue&type=script&lang=js&external"
export * from "./conversation-page.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__